<div>{{value || '&nbsp;'}}</div>